import { PropsWithChildren } from 'react';

import { Badge, useTheme } from '@mui/material';

interface IProps {
  count: number;
}

/**
 * Компонент badge для отображения счетчика уведомлений
 * @param root0 - пропсы
 * @param root0.count - количество уведомлений
 * @param root0.children - дочерние элементы
 */
export const NotificationsBadge = ({
  count,
  children
}: PropsWithChildren<IProps>) => {
  const { palette } = useTheme();

  const badgeContent = count > 99 ? '99+' : count;

  return (
    <Badge
      variant='standard'
      sx={{
        '& .MuiBadge-badge': {
          height: 22,
          width: 'fit-content',
          minWidth: 22,
          px: '5px',
          borderRadius: '100px',
          backgroundImage: `radial-gradient(572.63% 182.49% at 96.25% -35.94%,
              ${palette.secondary.light} 0%, ${palette.secondary.main} 32%, ${palette.secondary.dark} 100%)`,
          right: 4,
          top: 2
        }
      }}
      badgeContent={badgeContent}
      color='warning'
    >
      {children}
    </Badge>
  );
};
